import { Box, Stack, Typography } from "@mui/material";
import DownArrow from "src/assets/svg-icons/red-down-arrow.svg";
import UpArrow from "src/assets/svg-icons/green-up-arrow.svg";
import sarIcon from "src/assets/svg-icons/sar.svg";

interface IProps {
  label: string;
  value: string;
  percentage: number;
  isMoney?: boolean;
}

const AnalyticsBox = ({ label, value, percentage, isMoney }: IProps) => {
  return (
    <Box
      padding={{ xs: "10px", md: "25px 20px" }}
      bgcolor={"#242424"}
      borderRadius={"8px"}
      height={"100%"}
    >
      <Stack gap={2}>
        <Typography
          color={"#B0B0B0"}
          fontSize={{xs: "12px" , md: "14px"}}
          fontWeight={500}
          lineHeight={1}
        >
          {label}
        </Typography>
        <Stack direction={"row"} gap={2}>
          <Typography
            fontSize={{ xs: "14px", md: "16px" }}
            fontWeight={600}
            lineHeight={1}
          >
            {isMoney ? (
              <>
                <img height={14} src={sarIcon} alt="" />{" "}
              </>
            ) : null}
            {value}
          </Typography>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Typography
              color={
                percentage < 0
                  ? "#C02020"
                  : percentage === 0
                    ? "#B0B0B0"
                    : "#16AA75"
              }
              fontSize={{ xs: "12px", md: "14px" }}
              lineHeight={1}
            >
              {percentage}%
            </Typography>
            {percentage !== 0 && (
              <img width={10} src={percentage < 0 ? DownArrow : UpArrow} alt="" />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AnalyticsBox;
